import { render, staticRenderFns } from "./DiffDetails.vue?vue&type=template&id=0d92304f&scoped=true&"
import script from "./DiffDetails.vue?vue&type=script&lang=js&"
export * from "./DiffDetails.vue?vue&type=script&lang=js&"
import style0 from "./DiffDetails.vue?vue&type=style&index=0&id=0d92304f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92304f",
  null
  
)

export default component.exports